export default __webpack_public_path__ + "assets/images/8c63d45da60174f422b77107d3c8e6be.jpg";